var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vue-uploadbox-wrap br-8 position-relative",
      class: [
        _vm.classes,
        { "p-10 bg-lighten darken-on-hover": _vm.mode !== "aigeneration" },
      ],
      attrs: { id: "uploadBoxMainWrapper" },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex br-8 fg-white w-100",
          class: [
            _vm.background,
            {
              "border-white border-dashed border-1 h-100 darken-on-hover cursor-pointer p-3":
                _vm.mode !== "aigeneration",
            },
          ],
        },
        [
          _c("RouterView"),
          _vm._v(" "),
          _c("ErrorContainer", { attrs: { mode: "aigeneration" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }